import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, catchError, map, of } from 'rxjs';
import { PermissionsUser } from '../interfaces/permissions-user';
import { UserState } from '../ngrx/user/user.reducer';

@Injectable({
  providedIn: 'root'
})
export class PermissionsService {

  constructor(private store: Store<{ user: UserState }>) { }

  /**
   * Prende un id e un name e restituisce un object
   * @param idpermission
   * @param namepermission
   * @returns
   */
  getPermissionFunction(idpermission: number, namepermission: string): Observable<{
    permission: number,
    readonly: number
  } | null> {
    return this.store.select(state => state.user.permissions).pipe(
      map((val: PermissionsUser | null) => {
        if (val && val.functionality) {
          const objectsArray = val.functionality;
          const foundObject = objectsArray.find(obj => obj.id === idpermission && obj.name === namepermission);
          if (foundObject) {
            return {
              permission: 1,
              readonly: foundObject.readonly
            };
          } else {
            return null;
          }
        }else{ return null;}
      }),
      catchError(() => of(null)) // Gestisci errori e restituisci null in caso di errore
    );
  }


}

